import { render, staticRenderFns } from "./DollersGatewayList.vue?vue&type=template&id=36cd4494"
import script from "./DollersGatewayList.vue?vue&type=script&lang=js"
export * from "./DollersGatewayList.vue?vue&type=script&lang=js"
import style0 from "./DollersGatewayList.vue?vue&type=style&index=0&id=36cd4494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports